/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { GalaxyParent, AccountParent } from 'solis/rpc/parent';


export const createAccountRoutes = (routes) =>
{
  routes.createDetach('galaxy/accounts/:id', (application, { id }) =>
  {
    application.getGalaxy()?.unloadAccount({ id })
  });

  routes.createRecord('galaxy/accounts/:id/cass', {
    parent: GalaxyParent,
    load:   (galaxy, cass)   => galaxy.loadAccount(cass),
    unload: (galaxy, { id }) => galaxy.unloadAccount({ id }),
  });

  routes.createTable('galaxy/accounts/:account/boardViews', {
    parent: AccountParent,
    load:   (account, cass) => account.loadBoardView(cass),
    unload: (account, cass) => account.unloadBoardView(cass),
    values: (account) => account.getBoardViews().values(),
  });

  routes.createTable('galaxy/accounts/:account/colonyDrafts', {
    parent: AccountParent,
    load:   (account, cass) => account.loadColonyDraft(cass),
    unload: (account, cass) => account.unloadColonyDraft(cass),
    values: (account) => account.getColonyDrafts().values(),
  });

  routes.createTable('galaxy/accounts/:account/currentColonyViews', {
    parent: AccountParent,
    key:    (cass) => cass.colony,
    load:   (account, cass) => account.loadCurrentColonyView(cass),
    unload: (account, cass) => account.unloadCurrentColonyView(cass),
    values: (account) => account.getCurrentColonyViews().values(),
  });

  routes.createTable('galaxy/accounts/:account/originSectorViews', {
    parent: AccountParent,
    key:    (cass) => cass.sector,
    load:   (account, cass) => account.loadOriginSectorView(cass),
    unload: (account, cass) => account.unloadOriginSectorView(cass),
    values: (account) => account.getOriginSectorViews().values(),
  });
};
